import React from "react";
import { COLS, LABELS_PER_PAGE, previewMetrics } from "./labelLayout";

/**
 * Aperçu d'une planche A4.
 *
 * Toutes les mesures viennent de `previewMetrics`, exprimées en pourcentages de
 * la page : l'aperçu reste fidèle au PDF quelle que soit la largeur du
 * conteneur, sans media query ni recalcul JS.
 *
 * `cells` contient 24 entrées, chacune étant un résident ou `null`. En mode
 * planche entamée, cliquer une case l'attribue ou la libère.
 */
const A4Preview = ({ cells, onToggleCell, t }) => (
  <div className="mgr-lbl-sheet" style={{ aspectRatio: previewMetrics.aspectRatio }}>
    <div
      className="mgr-lbl-grid"
      style={{
        top: previewMetrics.paddingTop,
        left: previewMetrics.paddingLeft,
        width: previewMetrics.gridWidth,
        height: previewMetrics.gridHeight,
        gridTemplateColumns: `repeat(${COLS}, 1fr)`,
        columnGap: previewMetrics.columnGap,
        rowGap: previewMetrics.rowGap,
      }}
    >
      {Array.from({ length: LABELS_PER_PAGE }, (_, index) => {
        const resident = cells[index] || null;

        return (
          <button
            key={index}
            type="button"
            className={`mgr-lbl-cell${resident ? " is-filled" : ""}`}
            onClick={onToggleCell ? () => onToggleCell(index) : undefined}
            disabled={!onToggleCell}
            aria-label={
              resident
                ? `${resident.lastName} ${resident.firstName}`
                : t
                ? t("Empty label")
                : undefined
            }
          >
            {resident ? (
              <>
                <span className="mgr-lbl-cell-text">
                  <span className="mgr-lbl-cell-name">{resident.lastName}</span>
                  <span className="mgr-lbl-cell-first">{resident.firstName}</span>
                  <span className="mgr-lbl-cell-res">{resident.residence}</span>
                  <span className="mgr-lbl-cell-foot">
                    <span className="mgr-lbl-cell-id">{resident.woshId}</span>
                  </span>
                </span>
                <span className="mgr-lbl-cell-qr" aria-hidden="true" />
              </>
            ) : null}
          </button>
        );
      })}
    </div>
  </div>
);

export default A4Preview;
